import request from '@/utils/request'

const url = 'fault'

/** 获取故障列表 */
export function searchFaultList(data) {
  return request({
    url: `${url}/searchFaultList`,
    method: 'post',
    data
  })
}

/** 获取故障详情 */
export function getFaultDetail(data) {
  return request({
    url: `${url}/getFaultDetail/${data}`,
    method: 'get'
  })
}

/** 获取故障定义列表 */
export function getFaultDefinition(data, data2) {
  return request({
    url: `/fault/definition/${data}/${data2}`,
    method: 'get'
  })
}

/** 获取故障定义列表帅选 */
export function getFaultDefinitionSearch(data, data3) {
  return request({
    url: `/fault/definition/definitionSearch/${data}/${data3}`,
    method: 'get'
  })
}

/** 监控页面专用  故障定义*/
export function monitorDefinitionInfo(data) {
  return request({
    url: `/fault/definition/definitionInfo/${data}`,
    method: 'get'
  })
}

/** 获取实时故障 */
export function searchRealTimeFault(data) {
  return request({
    url: `/fault/searchRealTimeFault/${data}`,
    method: 'get'
  })
}

/** 消除故障 */
export function cancel(data) {
  return request({
    url: `${url}/cancel`,
    method: 'post',
    data
  })
}

/** 获取昨日故障占比 */
export function yesterdayStatistics() {
  return request({
    url: `/fault/yesterdayStatistics`,
    method: 'get'
  })
}

/** 获取单梯历史故障占比 */
export function getHisFaultStatistics(data) {
  return request({
    url: `/fault/getHisFaultStatistics/${data}`,
    method: 'get'
  })
}

/** 获取单梯不文明行为历史统计 */
export function getHospitalizationIonFaultStatistics(data) {
  return request({
    url: `/fault/getHospitalizationIonFaultStatistics/${data}`,
    method: 'get'
  })
}

/** 获取单梯不文明行为历史统计 */
export function saveHistoryVideo(elevatorCode, id, startTime, endTime) {
  return request({
    url: `/fault/camera/history/${elevatorCode}`,
    method: 'post',
    data: {
      id, startTime, endTime
    }
  })
}

/** 困人告警记录导出 */
export function searchFaultListExcel(data) {
  return request({
    url: `/fault/excel`,
    method: 'post',
    data,
    responseType: 'blob'
  })
}
